import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import type { Option } from '@/modules/common/types/option.type.ts';
import type { FieldType, PartialQueryOptionsGetter } from '@/modules/common/types/ui.ts';
import UiPrompt from '@/modules/ui/components/ui/UiPrompt.vue';
import type { MaskInputOptions } from 'maska';

type SchemaPromptArgs<T extends string | number> = SchemaControlArgs & {
  field: FieldType;
  getHints: PartialQueryOptionsGetter<T>;
  placeholder?: string;
  maxLength?: number;
  noResize?: boolean;
  rows?: number;
  autoGrow?: boolean;
  autoGrowMinHeight?: number;
  autoGrowMaxRows?: number;
  mask?: MaskInputOptions | string;
};

export class SchemaPrompt<T extends string | number> extends SchemaControl<Option<T>> {
  readonly component = UiPrompt;
  readonly field: FieldType;
  readonly getHints: PartialQueryOptionsGetter<T>;
  readonly placeholder?: string;
  readonly noClear: boolean;
  readonly noResize: boolean;
  readonly maxLength?: number;
  readonly rows?: number;
  readonly autoGrow: boolean;
  readonly autoGrowMinHeight?: number;
  readonly autoGrowMaxRows?: number;
  readonly mask?: MaskInputOptions | string;

  constructor(args: SchemaPromptArgs<T>) {
    super(args);

    this.field = args.field;
    this.getHints = args.getHints;
    this.placeholder = args.placeholder;
    this.noClear = !!args.required;
    this.noResize = !!args.noResize;
    this.maxLength = args.maxLength;
    this.rows = args.rows;
    this.autoGrow = !!args.autoGrow;
    this.autoGrowMinHeight = args.autoGrowMinHeight;
    this.autoGrowMaxRows = args.autoGrowMaxRows;
    this.mask = args.mask;
  }
}
